import { render, staticRenderFns } from "./first_table.vue?vue&type=template&id=3a2bd088&scoped=true&"
import script from "./first_table.vue?vue&type=script&lang=js&"
export * from "./first_table.vue?vue&type=script&lang=js&"
import style0 from "./first_table.vue?vue&type=style&index=0&id=3a2bd088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2bd088",
  null
  
)

export default component.exports